<template>
  <span
    :class="`${ wigo.length > 1 ? 'chip-wrap' : 'rai-wigo' } box`"
    @click="$emit('click', $event)"
  >
    <span>
      <option-chip-2
        v-for="option in wigo"
        :key="option.id"
        :option="option"
        :unselected="outlined"
        link
        :large="large"
        :show-details="showDetails"
        :class="`${draggable ? 'rai-draggable__chip' : ''}`"
      />
    </span>
  </span>
</template>

<script>
import OptionChip2 from '@/components/global/OptionChip2';

export default {
  name: "WigoChip",

  components: { OptionChip2 },

  props: {
    wigo: {
      type: Array,
      required: true,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    dragStartHandler (e, option) {
      if (!this.draggable) {
        // setting draggable to false is not sufficient..? wtf html5
        e.preventDefault()
      } else {
        e.dataTransfer.setData('id', option.id) // NB : not setting dataTransfer breaks draggable in firefox
        e.dataTransfer.setData('name', option.name)
      }
    },

    dragHandler (e) {
      if (e.screenY < 150) {
        window.scrollBy(0, -15)
      } else if ((window.outerHeight - e.screenY) < 80) {
        window.scrollBy(0, 15)
      }
    },
  }
};
</script>
<style scoped>
</style>